import { keys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

import {
	getCachedTimestamp,
	removeCachedTuple,
	setCachedTuple,
} from './commonContentIdTimestampTupleCacheUtils.ts';

const LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED =
	keys.LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED;

type OnNewAccessRequestCallback = (shouldShowIndicator: boolean) => void;

class NewAccessRequestIndicatorState {
	private _indicatorShown: boolean = false;
	private _subscribers: Set<OnNewAccessRequestCallback> = new Set();

	public subscribe(callback: OnNewAccessRequestCallback) {
		this._subscribers.add(callback);
		callback(this._indicatorShown);

		return () => {
			this._subscribers.delete(callback);
		};
	}

	public maybeShowIndicator(
		contentId: string,
		mostRecentPendingRequestCreatedAt: number | null | undefined,
	) {
		// This filters out 0, null and undefined
		if (!mostRecentPendingRequestCreatedAt) {
			return;
		}

		const lastTimeAccessRequestsDialogWasOpenedAt = getCachedTimestamp(
			contentId,
			LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED,
		);

		if (mostRecentPendingRequestCreatedAt > lastTimeAccessRequestsDialogWasOpenedAt) {
			this._indicatorShown = true;
			this._subscribers.forEach((sub) => sub(true));
		}
	}

	public hideIndicator(contentId: string) {
		this._indicatorShown = false;
		this._subscribers.forEach((sub) => sub(false));
		setCachedTuple(contentId, Date.now(), LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
	}

	public resetSubscribers() {
		this._indicatorShown = false;
		this._subscribers.clear();
	}

	public clearCache(contentId: string) {
		removeCachedTuple(contentId, LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED);
	}
}

export const NEW_ACCESS_REQUEST_INDICATOR_STATE_INSTANCE = new NewAccessRequestIndicatorState();
